import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { nameof } from 'ts-simple-nameof';
import { DialogDataService } from '../../../../../dialog/dialog-data.service';
import { DialogService } from '../../../../../dialog/dialog.service';
import { QuestionDefinition } from '../../../../../forms/form.types';
import { GenericFormGroupComponent } from '../../../../../forms/generic-form-group.component';
import { ValidStaffCode } from '../../../../../shared/interface/valid-staff-code.interface';
import { FacultyStaffTypeService } from '../faculty-staff-type.service';

@Component({
    selector: 'app-faculty-staff-type-edit',
    templateUrl: './faculty-staff-type-edit.component.html',
    styleUrls: ['./faculty-staff-type-edit.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class FacultyStaffTypeEditComponent extends GenericFormGroupComponent implements OnInit {
    controls: {
        id: FormControl<number>;
        staffCode: FormControl<string>;
        isEnabled: FormControl<boolean>;
    };

    questions: {
        staffCode: QuestionDefinition;
        isEnabled: QuestionDefinition;
    };

    constructor(
        private dataService: DialogDataService<ValidStaffCode>,
        private dialogService: DialogService<ValidStaffCode>,
        private service: FacultyStaffTypeService,
        protected renderer2: Renderer2
    ) {
        super(renderer2);
        this.controls = {
            id: new FormControl<number>(this.dataService?.data?.id, Validators.required),
            staffCode: new FormControl<string>(this.dataService?.data.staffCode, Validators.required),
            isEnabled: new FormControl<boolean>(this.dataService?.data?.isEnabled ?? false)
        };
        this.createFormGroup(this.controls);
        if (this.reflectionService.isNotNullOrEmpty(this.dataService.data.staffCode)) {
            this.controls.staffCode.disable();
        }
        this.questions = {
            staffCode: {
                input: {
                    discriminator: 'SELECT',
                    property: nameof<ValidStaffCode>((m) => m.staffCode),
                    control: this.controls.staffCode,
                    required: true,
                    options$: this.service.selectList({ q: this.controls.staffCode.value })
                }
            },
            isEnabled: {
                input: {
                    discriminator: 'CHECKBOX',
                    property: nameof<ValidStaffCode>((m) => m.isEnabled),
                    label: 'Check this check box to enable this code',
                    control: this.controls.isEnabled
                }
            }
        };
        this.dialogService.addFormGroup(this, this.dataService.uniqueId);
    }

    ngOnInit(): void {}

    onSave() {
        this.setSaving();
        this.service
            .savePromise(this.getFormValue(), 'Staff Code Saved!')
            .then((m) => {
                this.setDoneSaving();
                this.dialogService.send(this.dataService, m);
                this.controls.id.setValue(m.id);
            })
            .catch(() => {
                this.setDoneSaving();
            });
    }
}
